import useTranslation from '../../hooks/useTranslation'
import FloatingHeadline from '../../UI/FloatingHeadline/FloatingHeadline'
import Container from '../../UI/Container/Container'
import SlideInView from '../../UI/SlideInView/SlideInView'
import image from '../../../assets/image/timeline/image.png'

function TimelineSection() {
  const t = useTranslation()
  const tl = t.landing.timeline
  return (
    <div id="timeline" className="h-fit py-20 md:py-20 flex items-center justify-center">
      <div>
        <Container>
          <SlideInView>
            {/* <FloatingHeadline text={tl.topTitle} /> */}
            <img src={image} alt="Timeline" className="w-full h-full object-contain" />
          </SlideInView>
        </Container>
      </div>
    </div>
  )
}

export default TimelineSection
